var _path, _path2, _ellipse, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGroup375 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 100,
    viewBox: "0 0 129 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.292 15.0042V16.25C107.29 19.1702 106.345 22.0115 104.596 24.3504C102.848 26.6892 100.39 28.4002 97.5897 29.2282C94.7894 30.0562 91.7965 29.9567 89.0573 28.9448C86.3181 27.9328 83.9794 26.0624 82.39 23.6127C80.8006 21.163 80.0457 18.2651 80.2379 15.3513C80.43 12.4374 81.5589 9.66378 83.4562 7.44396C85.3535 5.22414 87.9175 3.67709 90.7658 3.03354C93.6142 2.38999 96.5943 2.68442 99.2616 3.87293",
    stroke: "#5F6C4A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.292 5.41666L93.75 18.9719L89.6875 14.9094",
    stroke: "#5F6C4A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.375,
    cy: 91.875,
    rx: 64.375,
    ry: 8.125,
    fill: "#F0F2EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.125 71.25V46.25C93.1239 45.154 92.8346 44.0775 92.2861 43.1286C91.7376 42.1797 90.9492 41.3918 90 40.8438L68.125 28.3437C67.1749 27.7952 66.0971 27.5064 65 27.5064C63.9029 27.5064 62.8251 27.7952 61.875 28.3437L40 40.8438C39.0508 41.3918 38.2624 42.1797 37.7139 43.1286C37.1654 44.0775 36.8761 45.154 36.875 46.25V71.25C36.8761 72.346 37.1654 73.4225 37.7139 74.3714C38.2624 75.3203 39.0508 76.1082 40 76.6562L61.875 89.1562C62.8251 89.7048 63.9029 89.9936 65 89.9936C66.0971 89.9936 67.1749 89.7048 68.125 89.1562L90 76.6562C90.9492 76.1082 91.7376 75.3203 92.2861 74.3714C92.8346 73.4225 93.1239 72.346 93.125 71.25Z",
    fill: "#E1E7D7",
    stroke: "#5F6C4A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0625 50.625L50.9375 34.4062",
    stroke: "#5F6C4A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7188 43L65 58.7812L92.2812 43",
    stroke: "#5F6C4A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65 90.25V58.75",
    stroke: "#5F6C4A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGroup375);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Group 375.c4ba78f64428a3f60973939bc63c372d.svg";